import React from "react";
import useScrollTop from "../../hooks/useScrollTop";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlay } from "@fortawesome/free-solid-svg-icons";

const StaticContentTandC = ({
  content,
  setUserType,
  userType,
  DropdownData,
}) => {
  useScrollTop();
  // console.log("content", content);

  const handleTypeChange = (e) => {
    // payload.faq_type = e.target.value;
    setUserType(e.target.value);
    // getStaticFaqList();
  };
  return (
    <div>
      <div className="d-flex gap-3  mb-3">
        <h3 className="">
          <FontAwesomeIcon className="play-icon" icon={faPlay} />
          Select Type:
        </h3>
        <select
          className="form-control form-select faq-select"
          value={userType}
          onChange={handleTypeChange}
        >
          {DropdownData.map((item, index) => (
            <option key={index} value={item.value}>
              {item.label}
            </option>
          ))}
        </select>
      </div>
      <div className="admission_para col-md-10">
        <p
          className="html_string"
          dangerouslySetInnerHTML={{
            __html:
              content?.body?.replaceAll("%22", `"`)?.replaceAll("%27", `'`) ||
              "NA",
          }}
        ></p>
      </div>
    </div>
  );
};

export default StaticContentTandC;
